import { OnInit, Component, EventEmitter, Input, Output, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { ApiRequest, FunctionPackageEnum } from "../../../../_models";
import { OrganisationFunctionService } from "../../../../_services/organisation-setting/organisation-function.service";
import { VendorService } from "../../../../_services/vendor/vendor.service";
import { GetVendorListRequest, VendorCategoryItemList, VendorCategoryList,GetPOandMappingDataReq, GetPOandMappingDataResp, SelectPurchaseOrderModel } from "../../../../_models/vendor/vendor.model";
import { POandMappingDataReqEnum } from "../../../../_models";

import { Claims } from "../../../../_models/common/claims";
import { AlertPanelModel } from "../../../../_models/common/alertPanelModel";
import { ClaimsService } from "../../../../_services/common/claims.service";
import { environment } from "../../../../../environments/environment";
import { CategoryItem } from "../../../../_models/manage-category/manage-category-list-response";
@Component({
  selector: "select-vendor-category-panel",
  templateUrl: "./select-vendor-category-panel.component.html",
  standalone: false
})
export class SelectVendorCategoryPanelComponent implements OnInit, OnDestroy {

  @Input()
  inputData: any;

  @Output() closePanelEvent = new EventEmitter<boolean>();
  @Output() selectItemEvent = new EventEmitter<any>();

  claimsSubscription: Subscription;
  claims: Claims;
  param: any;
  vendorCategoryList = <VendorCategoryList[]>[];
  vendorCategoryItemList = <VendorCategoryItemList[]>[];
  recentCategoryList: any = [];
  selectedOrgExpenseCategoryId: number = 0;
  selectedCategoryModel: VendorCategoryList;
  selectedCategoryItemModel: VendorCategoryItemList;
  selectedPurchaseOrderModel: SelectPurchaseOrderModel;
  showPopUpForNoCategorySetup: boolean;
  showPopUpForNoCategorySetupModel: AlertPanelModel;
  isAdvancesDisplay: boolean = false;
  advancesList: any[] = [];
  selectedAdvanceId: number = 0;
  isAssignCategoriesToGradePurchased: boolean = false;
  isSupplierPurchased: boolean = false;
  hasReciept : boolean=false;
  purchaseOrdersList: any = [];
  selectedPurchaseOrderId: number = 0;
  panelHeading: string;
  constructor(
    private claimsService: ClaimsService,
    private vendorService: VendorService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {
    this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit() {
    if(this.inputData.type == 'vendorCategoryName' || this.inputData.type == 'vendorCategoryItemName'){
      if(this.inputData.type == 'vendorCategoryName'){
this.panelHeading = this.translate.instant('vendor_v1_msg46');
      }
      else{
this.panelHeading = 'Select Item';
      }
      
      this.GetCategoryList();
      this.fnSetExpenseCategoryInputValues();
    }
    else if(this.inputData.type=='purchaseOrderNumber'){
      this.panelHeading = this.translate.instant('vendor_cat_list_msg8');
      this.getPurchaseOrderNumberList();
      this.fnSetPurchaseOrderValue();
    }
  }
    

  ngOnDestroy(): void {
    this.claimsSubscription.unsubscribe();
  }

  GetCategoryList() {
    let request = new ApiRequest<GetVendorListRequest>(
        "GetVendorList",
        environment.applicationVersion,
        environment.requestId
      );
      let requestInfo = new GetVendorListRequest();
      requestInfo.action = 1;
      requestInfo.OrgId = this.claims.OrgId;
      requestInfo.userId = this.claims.UserId;
      request.requestInfo = requestInfo;
    this.vendorService
      .GetCategoryList(request)
      .subscribe((response) => {
        if (response.responseInfo != null) {
          if(this.inputData.type == 'vendorCategoryName')
          {
            this.vendorCategoryList = response.responseInfo.vendorCategoryList;
          }
          else if(this.inputData.type == 'vendorCategoryItemName')
          {
            let category = response.responseInfo.vendorCategoryList
                          .filter(a=>a.orgExpenseCategoryId == this.inputData.orgExpenseCategoryId);
            this.vendorCategoryItemList = category[0].vendorCategoryItemList;
          }
          
          this.cdr.detectChanges();   
        }
      });
  }
  fnSelectCategory(item: any) {
    if (item) {      
      this.selectedCategoryModel = new VendorCategoryList();
      this.selectedCategoryModel.orgExpenseCategoryId = item.orgExpenseCategoryId;
      this.selectedCategoryModel.vendorCategoryName = item.vendorCategoryName;
      this.selectItemEvent.emit(this.selectedCategoryModel);
    }
  }
  fnSelectCategoryItem(item: any) {
    if (item) {      
      this.selectedCategoryItemModel = new VendorCategoryItemList();
      this.selectedCategoryItemModel.orgExpenseCategoryId = item.orgExpenseCategoryId;
      this.selectedCategoryItemModel.categoryItemId = item.categoryItemId;
      this.selectedCategoryItemModel.vendorCategoryItemName = item.vendorCategoryItemName;
      this.selectedCategoryItemModel.receiptInfo = item.receiptInfo;
      this.selectItemEvent.emit(this.selectedCategoryItemModel);
    }
  }
  fnSelectPurchaseOrder(item: any) {
    if(item){
      this.selectedPurchaseOrderModel = new SelectPurchaseOrderModel();
      this.selectedPurchaseOrderModel.purchaseOrderId = item.purchaseOrderId;
      this.selectedPurchaseOrderModel.purchaseOrderNumber = item.purchaseOrderNumber;
      this.selectItemEvent.emit(this.selectedPurchaseOrderModel);
  }
}

  fnClosePanel(isClose: boolean) {
    this.closePanelEvent.emit(isClose);
  }
  fnSetExpenseCategoryInputValues() {
    if (this.inputData) {
      this.selectedOrgExpenseCategoryId = this.inputData.orgExpenseCategoryId;
    }
  }
  fnSetPurchaseOrderValue(){
    if(this.inputData && this.inputData.purchaseOrderId){
      this.selectedPurchaseOrderId = this.inputData.purchaseOrderId;
    }
  }
  getPurchaseOrderNumberList() {

    let request = new ApiRequest<GetPOandMappingDataReq>("GetPOandMappingData", environment.applicationVersion, environment.requestId);
    let reqInfo = new GetPOandMappingDataReq();
    reqInfo.action = POandMappingDataReqEnum.FinalPO;
    reqInfo.orgId = this.claims.OrgId;
    request.requestInfo = reqInfo;
    this.vendorService
      .GetPOandMappingData(request)
      .subscribe((response) => {
        if (response.responseInfo != null) {
          if (response.responseInfo != null && response.responseInfo.purchaseOrderAndMappings != null) {
            this.purchaseOrdersList = response.responseInfo.purchaseOrderAndMappings.map(po => ({
              purchaseOrderId: po.purchaseOrderId,
              purchaseOrderNumber: po.purchaseOrderNumber
            }));
            this.cdr.detectChanges();   
          }

        }
      });
  }

}
